<template>
  <div v-if="analyticsData!==null">
    <div class="row">
      <div class="col-md-12">
        <p-button outline type="info" size="sm" round @click="$router.go(-1)">
          <i class="fa fa-chevron-circle-left"></i>
          Back
        </p-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div style="margin-bottom:10px;">
          <h4 style="margin:0px; padding:0px;">
            {{analyticsData.name}}
            <span
              style="font-size:12px;"
            >created {{analyticsData.dateAddedString}}</span>
          </h4>

          <p style="padding:0px; margin:0px">
            <a
              :href="analyticsData.trackingUrl"
              target="_blank"
              class="detail-text"
            >{{analyticsData.trackingUrl}}</a>
          </p>
          <p style="padding:0px; margin:0px">
            <a
              :href="'https://convo.is/'+analyticsData.shortLink.shortcode"
              target="_blank"
            >convo.is/{{analyticsData.shortLink.shortcode}}</a>
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card
          type="primary"
          icon="fas fa-mouse"
          small-title="Human Clicks"
          :title="analyticsData.humanClicksString"
        >
          <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
          </div>-->
        </stats-card>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card
          type="primary"
          icon="fas fa-globe"
          small-title="All CLicks"
          :title="analyticsData.totalClicksString"
        >
          <!--<div class="stats" slot="footer">
            <i class="nc-icon nc-refresh-69"></i>
            Last Updated
          </div>-->
        </stats-card>
      </div>
    </div>
    <div class="row" style="clear:both;">
      <div class="col-md-12">
        <div class="row" style="clear:both;">
          <div class="col-md-5">
            <h5
              id="demographic-section"
              style="margin:0px; padding: 0px;"
              class="analytics-section-title"
            >Device Details</h5>
          </div>
        </div>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6" v-if="osSummaryApex !== null">
        <card>
          <template slot="header">
            <p class="card-category">Clicks by OS</p>
          </template>
          <apexchart
            width="445"
            type="pie"
            :options="osSummaryApex.options"
            :series="osSummaryApex.options.series"
          ></apexchart>
        </card>
      </div>
      <div class="col-md-6" v-if="browserSummaryApex !== null">
        <card>
          <template slot="header">
            <p class="card-category">Clicks by Browser</p>
          </template>
          <apexchart
            width="500"
            type="bar"
            :options="browserSummaryApex.options"
            :series="browserSummaryApex.series"
          ></apexchart>
        </card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12" v-if="countryChart !== null">
        <card>
          <div class="row">
            <div class="col-md-6">
              <div slot="header">
                <p class="card-category">Clicks by Country</p>
              </div>
              <div>
                <GChart
                  :settings="{  packages: ['corechart', 'table', 'map', 'geochart'], mapsApiKey: 'AIzaSyBrpjYwFfW979atnhjWXiG7K5CQRE4rJzA'  }"
                  type="GeoChart"
                  :data="countryChart.data"
                  :options="countryChart.options"
                />
              </div>
            </div>
            <div class="col-md-6" v-if="cityData !== null" style="padding-left: 25px;">
              <div slot="header">
                <p class="card-category">Top Cities</p>
              </div>
              <el-table :data="cityData">
                <el-table-column label="#" width="50px">
                  <template slot-scope="props">{{props.$index + 1}}.</template>
                </el-table-column>
                <el-table-column label="City" property="name" width="250px"></el-table-column>
                <el-table-column label="Clicks" property="score" width="150px"></el-table-column>
              </el-table>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="lds-dual-ring"></div>
  </div>
</template>

<script>
import firebase from "firebase";
import axios from "axios";
import moment from "moment";
import _ from "underscore";
import { mapGetters, mapActions } from "vuex";
import timeVars from "@/config/timeVars";
import ChartCard from "@/components/UIComponents/Cards/ChartCard";
import LineChart from "@/components/UIComponents/Charts/LineChart";
import BarChart from "@/components/UIComponents/Charts/BarChart";
import PieChart from "@/components/UIComponents/Charts/PieChart";
import StatsCard from "@/components/UIComponents/Cards/StatsCard";
import { VueDatamaps } from "vue-datamaps";
import VueApexCharts from "vue-apexcharts";
import { GChart } from "vue-google-charts";
import store from "@/store/index.js";
import Datepicker from "vuejs-datepicker";
import numeral from "numeral";

import {
  clientProfileReadApi,
  userLoadApi,
  fbGraphInstagramCheck,
  userRelatedProfilesApi,
  trackingLinkAnalyticsApi,
} from "@/config/appSettings";
import Axios from "axios";
const tooltipOptions = {
  tooltipFillColor: "rgba(0,0,0,0.5)",
  tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  tooltipFontSize: 14,
  tooltipFontStyle: "normal",
  tooltipFontColor: "#fff",
  tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  tooltipTitleFontSize: 14,
  tooltipTitleFontStyle: "bold",
  tooltipTitleFontColor: "#fff",
  tooltipYPadding: 6,
  tooltipXPadding: 6,
  tooltipCaretSize: 8,
  tooltipCornerRadius: 6,
  tooltipXOffset: 10,
};

export default {
  name: "InstagramAnalytics",
  data: () => ({
    alertMsg: "",
    alertType: "",
    displayAlert: false,
    isTeam: null,
    isClient: null,
    isInfluencer: null,
    clientDetails: null,
    auth: null,
    getTime: null,
    insightChart: {},
    insightsLoaded: false,
    profileVisitsChart: {},
    followerChart: {},
    profileVisitsChartLoaded: false,
    websiteClicksChart: {},
    websiteClicksChartLoaded: false,
    websiteClicksTotal: 0,
    profileVisitsTotal: 0,
    impressionsTotal: 0,
    followersTotal: 0,
    reachTotal: 0,
    loadingOverlay: false,
    loadingOverlayText: null,
    instagramLinked: null,
    osSummary: null,
    osSummaryChart: null,
    browserSummaryChart: null,
    browserSummaryApex: null,
    osSummaryApex: null,
    countryChart: null,
    cityData: null,
    analyticsData: null,
    startDate: null,
    endDate: null,
    pickerStart: null,
    pickerEnd: null,
  }),
  components: {
    ChartCard,
    LineChart,
    BarChart,
    PieChart,
    VueDatamaps,
    apexchart: VueApexCharts,
    GChart,
    StatsCard,
    Datepicker,
  },
  created: function () {
    let msgData = this.$route.query;
    //console.log("HERE IS THE CONFIRM DATA: ", confirmData);
    this.alertMsg = msgData.msg;
    this.alertType = msgData.msg_type;
    if (msgData.msg_show === true) {
      this.displayAlert = true;
    }
  },
  computed: mapGetters(["profileStore", "relatedProfileStore"]),
  methods: {
    async checkNoAuthProfiles() {
      try {
        if (this.isTeam == true) {
          //console.log("ACTIVE INSTAGRAM:", this.activeInstagram);
          let noAuthProfileCheckResponse = await axios.get(
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${this.activeInstagram}`
          );
          /*console.log(
            "RELATED PROFILE AUTH CHECK:",
            noAuthProfileCheckResponse.data
          );*/
          if (noAuthProfileCheckResponse.data.exists === false) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.noAuthProfiles = this.relatedProfiles;
            this.instagramLinked = false;
          }
          if (noAuthProfileCheckResponse.data.exists == true) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.instagramLinked = true;
          }
          return;
        }
        // console.log("CHECKING RELATED PROFILES: ", this.relatedProfiles);
        if (
          this.relatedProfileStore !== null &&
          typeof this.relatedProfileStore !== "undefined"
        ) {
          this.relatedProfiles = this.relatedProfileStore;
        }
        if (
          this.relatedProfiles !== null &&
          typeof this.relatedProfiles !== "undefined"
        ) {
          // console.log("RESETTING PROFILES:", this.relatedProfiles);
          this.relatedProfileList = this.relatedProfiles.map((x) => {
            return x.instagramProfile;
          });
          let instagramProfileString = this.relatedProfileList.join(",");
          /*console.log(
            "LINK:",
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );*/
          let noAuthProfileCheckResponse = await axios.get(
            `${fbGraphInstagramCheck}/?usertoken=${this.auth}&profiles=${instagramProfileString}`
          );
          /*console.log(
            "RELATED PROFILE AUTH CHECK:",
            noAuthProfileCheckResponse.data
          );*/
          if (noAuthProfileCheckResponse.data.exists === false) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.noAuthProfiles = this.relatedProfiles;
            this.instagramLinked = false;
          }
          if (noAuthProfileCheckResponse.data.exists == true) {
            // TO CHANGE LATER NEED TO DEDUPE AUTHED PROFILES FROM NON AUTHED PROFILES
            this.instagramLinked = true;
          }
        } else {
          //console.log("RELATED PROFILES NOT FOUND");
          if (this.isTeam !== true) {
            if (this.relatedProfileStore == null) {
              let relatedProfileResponse = await axios.get(
                `${userRelatedProfilesApi}/?usertoken=${this.auth}`
              );
              this.relatedProfiles = relatedProfileResponse.data.result;
              store.dispatch(
                "storeRelatedProfiles",
                relatedProfileResponse.data.result
              );
            } else {
              this.relatedProfiles = this.relatedProfileStore;
            }
            //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
          }
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async formatDate(dateInput) {
      let thisDate = moment(dateInput).format("yyyy-MM-DD");
      console.log("THIS DATE:", thisDate);
    },
    async loadLinkAnalytics() {
      let linkAnalyticsUrl = `${trackingLinkAnalyticsApi}/?usertoken=${this.auth}&link=${this.$route.params.linkId}&start=${this.startDate}&end=${this.endDate}`;
      console.log("LINK ANALYTICS URL:", linkAnalyticsUrl);
      let linkAnalyticsResponse = await axios.get(linkAnalyticsUrl);
      console.log("LINK ANALYTICS RESPONSE:", linkAnalyticsResponse.data);
      if (linkAnalyticsResponse.data.success == true) {
        this.analyticsData = JSON.parse(
          JSON.stringify(linkAnalyticsResponse.data.result)
        );
        let linkUrl = this.analyticsData.landingPage;
        let utmCodes = [];
        let utmString;
        if (
          typeof this.analyticsData.utmCampaign != "undefined" &&
          this.analyticsData.utmCampaign.trim() !== ""
        ) {
          utmCodes.push(`utm_campaign=${this.analyticsData.utmCampaign}`);
        }
        if (
          typeof this.analyticsData.utmSource != "undefined" &&
          this.analyticsData.utmSource.trim() !== ""
        ) {
          utmCodes.push(`utm_source=${this.analyticsData.utmSource}`);
        }
        if (
          typeof this.analyticsData.utmMedium != "undefined" &&
          this.analyticsData.utmMedium.trim() !== ""
        ) {
          utmCodes.push(`utm_medium=${this.analyticsData.utmMedium}`);
        }
        if (
          typeof this.analyticsData.utmTerm != "undefined" &&
          this.analyticsData.utmTerm.trim() !== ""
        ) {
          utmCodes.push(`utm_term=${this.analyticsData.utmTerm}`);
        }
        if (
          typeof this.analyticsData.utmContent != "undefined" &&
          this.analyticsData.utmContent.trim() !== ""
        ) {
          utmCodes.push(`utm_content=${this.analyticsData.utmContent}`);
        }
        if (utmCodes.length > 1) {
          utmString = utmCodes.join("&");
          linkUrl = `${linkUrl}/?${utmString}`;
        }
        if (utmCodes.length === 1) {
          utmString = utmCodes[0];
          linkUrl = `${linkUrl}/?${utmString}`;
        }
        this.analyticsData.totalClicksString = numeral(
          this.analyticsData.analytics.totalClicks
        ).format("0,0");
        this.analyticsData.humanClicksString = numeral(
          this.analyticsData.analytics.humanClicks
        ).format("0,0");
        this.analyticsData.trackingUrl = linkUrl;
        this.analyticsData.dateAddedString = moment
          .unix(this.analyticsData.dateAdded)
          .format("M/D/YY");

        console.log("FINAL ANALYTICS DATA:", this.analyticsData);
      }
    },
    async loadCountryChart() {
      this.countryChart = {};
      this.countryChart.data = [["Country", "Followers"]];
      let countryDataFormat = this.analyticsData.analytics.country.map((x) => {
        //console.log(x);
        let countryArray = [];
        countryArray[0] = x.country;
        countryArray[1] = x.score;
        return countryArray;
      });
      console.log("FORMATTED COUNTRY DATA:", countryDataFormat);
      this.countryChart.data = this.countryChart.data.concat(countryDataFormat);
      this.countryChart.options = {};
    },
    async loadCityData() {
      this.cityData = _.sortBy(this.analyticsData.analytics.city, "score")
        .reverse()
        .slice(0, 10);
      console.log("CITY DATA", this.cityData);
    },
    async loadOsChart() {
      // GENDER BREAKDOWN
      let osData = _.sortBy(this.analyticsData.analytics.os, "score").reverse();
      let osTypeLabels = osData.map((x) => {
        return x.os;
      });
      let osCounts = osData.map((x) => {
        return x.score;
      });

      console.log("GENDER DATA:", osData);

      this.osSummaryApex = {};
      this.osSummaryApex.options = {
        series: osCounts,
        chart: {
          id: "Click-OS-Data",
          width: 380,
          type: "pie",
          legend: {
            position: "bottom",
          },
        },
        dataLabels: {
          enabled: true,

          dropShadow: {
            enabled: false,
          },
        },
        labels: osTypeLabels,
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      };

      this.osSummaryChart = {
        labels: osTypeLabels,
        datasets: [
          {
            label: "Gender",
            pointRadius: 0,
            pointHoverRadius: 5,
            backgroundColor: ["#4acccd", "#fcc468", "#e3e3e3"],
            borderWidth: 0,
            data: osCounts,
          },
        ],
        options: {
          chartPadding: 30,
          labelOffset: 50,
          labelDirection: "explode",
        },
      };
    },
    async loadBrowserChart() {
      // GENDER BREAKDOWN
      let browserTypeLabels = this.analyticsData.analytics.browser.map((x) => {
        return x.browser;
      });

      let browserCounts = this.analyticsData.analytics.browser.map((x) => {
        return x.score;
      });
      console.log("BROWSER DATA:", browserCounts);

      this.browserSummaryApex = {};
      this.browserSummaryApex.options = {
        chart: {
          id: "Browser-Clicks",
        },
        xaxis: {
          categories: browserTypeLabels,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
      };
      this.browserSummaryApex.series = [
        {
          name: "total",
          data: browserCounts,
        },
      ];
    },
    async resetDates() {
      //console.log("START DATE", this.pickerStart);
      let startDateString = new Date(this.pickerStart); // Your timezone!
      this.startDate = startDateString.getTime() / 1000;
      //console.log("START TIMESTAMP: ", this.startDate);
      //console.log("END DATE", this.pickerEnd);
      let endDateString = new Date(this.pickerEnd); // Your timezone!
      this.endDate = endDateString.getTime() / 1000;
      //console.log("END TIMESTAMP: ", this.endDate);
      if (this.startDate < this.endDate) {
        let startDateUrl = moment
          .unix(this.startDate)
          .startOf("day")
          .format("YYYY-MM-DD");
        let endDateUrl = moment
          .unix(this.endDate)
          .endOf("day")
          .format("YYYY-MM-DD");
        this.analyticsData = null;
        await this.loadProfileAnalytics();
        await this.loadPostAnalytics();
        if (
          startDateUrl == this.$route.query.start &&
          endDateUrl == this.$route.query.end
        ) {
          return;
        }

        this.$router.push(
          `/tracking-links/analytics/${this.$route.params.linkId}/?start=${startDateUrl}&end=${endDateUrl}`
        );
      }
    },

    async getRelatedProfiles() {
      //console.log("RELATED PROFILES:", this.relatedProfileStore);

      if (this.isTeam !== true) {
        if (
          this.relatedProfileStore == null ||
          typeof this.relatedProfileStore == "undefined"
        ) {
          let relatedProfileUrl = `${userRelatedProfilesApi}/?usertoken=${this.auth}`;
          //console.log("RELATED PROFILE URL:", relatedProfileUrl);
          let relatedProfileResponse = await axios.get(relatedProfileUrl);
          this.relatedProfiles = relatedProfileResponse.data.result;
          store.dispatch(
            "storeRelatedProfiles",
            relatedProfileResponse.data.result
          );
        } else {
          this.relatedProfiles = this.relatedProfileStore;
        }
        //console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
      }
    },
    async setProfileType() {
      //console.log("PROFILE STORE:", this.profileStore);
      if (this.profileStore.isTeam === true) {
        this.isTeam = true;
      }
      try {
        if (this.profileStore.profileTypes.length > 0) {
          if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
            this.isInfluencer = true;
          }
          if (this.profileStore.profileTypes.indexOf("client") !== -1) {
            this.isClient = true;
          }
        }
      } catch (err) {
        //console.log("ERROR:", err);
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE
      //console.log("PROFILE STORE MAIN:", this.profileStore);
      if (this.profileStore === false) {
        let profileData = await axios.get(`${userLoadApi}${this.auth}`);
        //console.log("PROFILE DATA MAIN:", profileData.data);
        if (profileData.data.success === true) {
          if (profileData.data.result.isTeam === true) {
            this.isTeam = true;
          }
          try {
            if (profileData.data.result.profileTypes.length > 0) {
              if (
                profileData.data.result.profileTypes.indexOf("influencer") !==
                -1
              ) {
                this.isInfluencer = true;
              }
              if (
                profileData.data.result.profileTypes.indexOf("client") !== -1
              ) {
                this.isClient = true;
              }
            }
          } catch (err) {
            //console.log("ERROR:", err);
          }
        }
      }
    },

    async loadPageContent() {
      await this.setProfileType();
      await this.getRelatedProfiles();
      this.getTime = await timeVars.timeInfo();
      //console.log("UTC TIME:", this.getTime.utcTime);

      this.endDate =
        moment.unix(this.getTime.utcTime).startOf("day").utc() / 1000;
      this.startDate =
        moment.unix(this.endDate).utc().subtract(7, "days") / 1000;

      //console.log("GENERIC START DATE:", this.startDate);
      //console.log("GENERIC END DATE:", this.endDate);

      this.pickerStart = new Date(this.startDate * 1000);
      if (typeof this.$route.query.start !== "undefined") {
        let startTs = moment(this.$route.query.start).utc().valueOf() / 1000;
        //console.log("START TS:", startTs);
        if (!isNaN(startTs)) {
          this.startDate = startTs;
          this.pickerStart = new Date(startTs * 1000);
          //console.log("PICKER START:", this.pickerStart);
        }
      }
      this.pickerEnd = new Date(this.endDate * 1000);
      if (typeof this.$route.query.end !== "undefined") {
        let endTs = moment(this.$route.query.end).utc().valueOf() / 1000;
        //console.log("END TS:", endTs);
        if (!isNaN(endTs)) {
          this.endDate = endTs;
          this.pickerEnd = new Date(this.endDate * 1000);
          //console.log("PICKER END:", this.pickerEnd);
        }
      }

      if (this.isClient == true) {
        if (
          this.relatedProfiles !== null &&
          typeof this.relatedProfiles !== "undefined"
        ) {
          if (this.relatedProfileStore.length > 0) {
            this.activeInstagram = this.relatedProfileStore[0].instagramProfile;
          }
        }
      }
      if (this.isInfluencer == true) {
        if (this.relatedProfiles !== null) {
          if (this.relatedProfileStore.length > 0) {
            this.activeInstagram = this.relatedProfileStore[0].instagramProfile;
          }
        }
      }

      if (this.isTeam == true) {
        this.activeInstagram = this.$route.params.instagram;
      }

      await this.checkNoAuthProfiles();
      await this.loadLinkAnalytics();
      if (this.analyticsData !== null) {
        this.loadCountryChart();
        this.loadCityData();
        this.loadOsChart();
        this.loadBrowserChart();
      }

      this.loadingOverlay = false;
    },
  },
  mounted() {
    this.loadingOverlay = true;
    this.loadingOverlayText = "Loading...";
    this.auth = firebase.auth().currentUser.uid;

    this.loadPageContent();
  },
};
</script>

<style scoped>
.center-align {
  text-align: center;
}
.post-preview {
  float: left;
  padding: 10px;
  height: 150px;
  width: 150px;
  overflow: hidden;
  cursor: pointer;
}

.img-row {
  object-fit: cover;
}
</style>